import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import AuthService from '../../../services/auth.service';
import assetUrl from '../../../utils/assetUrl';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentUser, setCurrentUser] = useState<any>(null);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Check if user is logged in
  useEffect(() => {
    const user = AuthService.getCurrentUser();
    setCurrentUser(user);
  }, [location]); // Re-check when route changes

  const handleLogout = () => {
    AuthService.logout();
    setCurrentUser(null);
    navigate('/');
  };

  // Close menu when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Disable body scroll when menu is open (optional, good for UX)
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-inner">
        <div className="navbar-logo">
          <Link to="/">
            <img src={assetUrl('/img/logo_white.png')} alt="Myft Hair Studio" className="logo-img" />
          </Link>
        </div>
        
        <div className="menu-icon" onClick={toggleMenu}>
          <div className={isOpen ? "bar open" : "bar"}></div>
          <div className={isOpen ? "bar open" : "bar"}></div>
          <div className={isOpen ? "bar open" : "bar"}></div>
        </div>

        <ul className={isOpen ? "navbar-links active" : "navbar-links"}>
          <li><Link to="/men">Ανδρικό</Link></li>
          <li><Link to="/women">Γυναικείο</Link></li>
          <li><Link to="/products">Τα Προϊόντα Μας</Link></li>
          
          {currentUser ? (
            <>
              <li>
                <Link
                  to={currentUser.roles && currentUser.roles.includes('ROLE_ADMIN') ? "/admin" : "/dashboard"}
                  className="user-link"
                >
                  <i className="far fa-user"></i> {currentUser.firstName}
                </Link>
              </li>
              <li><button onClick={handleLogout} className="logout-nav-btn">Αποσύνδεση</button></li>
            </>
          ) : (
            <>
              <li><Link to="/login">Sign In</Link></li>
              <li><Link to="/signup">Sign Up</Link></li>
            </>
          )}
        </ul>
      </div>
      {/* Overlay backdrop for mobile */}
      {isOpen && <div className="navbar-overlay" onClick={toggleMenu}></div>}
    </nav>
  );
}

export default Navbar;
